import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveUpdateDeleteAnaliseOrcamentaria({ commit }, data) {
      try {
        return await api.post('/analises-orcamentarias', data)
      } catch (error) {
        throw error
      }
    },

    async getAnalisesOrcamentarias({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        Object.entries(filters).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => params.append(`${key}[]`, v))
          } else {
            params.append(key, value)
          }
        })

        const response = await api.get(`/analises-orcamentarias?${params}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
